import React from "react";
import "./works.css";
import playstore from "../../assets/playstore.png"; // your Play Store icon
import step1 from "../../assets/stepone.png"; // replace with actual screenshots
import step2 from "../../assets/steptwo.png";
import step3 from "../../assets/stepthree.png";

const Works = () => {
  return (
    <section id="download" className="download-section">
      <div className="download-content">
        <h2 className="download-title">Download<spam className="miogra_"> Miogra</spam></h2>
        <p className="download-desc">
          Experience food delivery, grocery shopping, and taxi booking — all in one app.
        </p>
        <div className="download-actions">
          <a
            href="https://play.google.com/store/apps/details?id=com.gobbogtechnologies.miograuser&hl=en_IN"
            target="_blank"
            rel="noopener noreferrer"
            className="download-btn"
          >
            <img src={playstore} alt="Play Store" className="download-btn-img" />
            Get on Play Store
          </a>

          <div className="qr-container">
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://play.google.com/store/apps/details?id=com.gobbogtechnologies.miograuser&hl=en_IN`}
              alt="Miogra QR Code"
              className="qr-image"
            />
            <p className="qr-text">Scan to Install</p>
          </div>
        </div>

        <h3 className="steps-title">How to Use Miogra</h3>
        <div className="steps-container">
          <div className="step-card">
            <img src={step1} alt="Step 1" className="step-img" />
            <p className="step-text">1️⃣ Download the app from Play Store.</p>
          </div>
          <div className="step-card">
            <img src={step2} alt="Step 2" className="step-img" />
            <p className="step-text">2️⃣ Sign up and choose your city.</p>
          </div>
          <div className="step-card">
            <img src={step3} alt="Step 3" className="step-img" />
            <p className="step-text">3️⃣ Start ordering food, groceries, or booking rides!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Works;
